import memoize from 'fast-memoize';
import { SpecialEventType } from '../../data/types/system/special-event/special-event-type';
import { SpecialEventConfig } from '../../data/types/system/special-event/special-event-config';
import { specialEventConfigs } from './special-event.configs';

export const getSpecialEventConfig = memoize(
  (specialEventType: SpecialEventType): SpecialEventConfig =>
    specialEventConfigs[specialEventType],
);
